import { render, staticRenderFns } from "./InventoryHomeView.vue?vue&type=template&id=2867948b&scoped=true"
import script from "./InventoryHomeView.vue?vue&type=script&lang=js"
export * from "./InventoryHomeView.vue?vue&type=script&lang=js"
import style0 from "./InventoryHomeView.vue?vue&type=style&index=0&id=2867948b&prod&lang=scss&scoped=true"
import style1 from "./InventoryHomeView.vue?vue&type=style&index=1&id=2867948b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2867948b",
  null
  
)

export default component.exports